import React from 'react';
import { connect } from 'react-redux';
import { selectIngredientOption } from './actions';
import { defaultIngredientOption } from 'shared/models/product';
import { track } from 'shared/models/analytic';
import Select from 'react-select';
import View from 'components/ui/view';
import Text from 'components/ui/text';

function ProductIngredients({ ingredients, sku }) {
  return (
    <View padding="sm" className="product-ingredients text-center">
      <View margin="sm">
        <Text title weight="med" size="xs">
          Choose Your Ingredients
        </Text>
      </View>
      {ingredients.map(ingredient => (
        <ConnectedIngredientSelector
          collectionSKU={sku}
          ingredient={ingredient}
          key={ingredient._id}
        />
      ))}
    </View>
  );
}

class IngredientSelector extends React.Component {
  constructor(props) {
    super(props);
    const selectedProduct = defaultIngredientOption(props.ingredient);
    this.state = {
      selected: {
        value: { product: selectedProduct },
        label: selectedProduct.sku_id
      },
      options: this.options(props.ingredient)
    };
  }

  options(ingredient) {
    if (!ingredient.options.length) return [];
    return ingredient.options
      .map(product => ({ value: { product }, label: product.sku_id }))
      .concat(
        ingredient.required
          ? []
          : {
              value: {
                product: null,
                name: ingredient.name,
                _id: ingredient._id
              },
              label: 'none'
            }
      );
  }

  select(selected) {
    const prevProduct = this.state.selected.value.product || {};
    const nextProduct = selected.value.product || {};

    this.setState({ selected });

    const ingredient = this.props.ingredient;
    const product = selected.value.product;
    this.props.selectIngredientOption(ingredient, product);

    track('Collection Updated', {
      collection: this.props.collectionSKU,
      from: prevProduct.sku_id,
      to: nextProduct.sku_id
    });
  }

  renderValue({ value }) {
    const product = value.product;
    if (!product)
      return (
        <div className="product-ingredient__row">
          <div className="product-ingredient__title">
            <Text tag="span" title weight="bold" size="xs">
              {value.name}
            </Text>{' '}
            <Text
              tag="span"
              className="text-uppercase"
              secondary
              weight="med"
              size="xs"
            >
              (None)
            </Text>
          </div>
        </div>
      );
    return this._renderIngredientOption(product);
  }

  renderOption({ value }) {
    const product = value.product;
    if (!product)
      return (
        <div className="product-ingredient__row product-ingredient__row--center">
          <Text tag="span" title secondary weight="med" size="xs">
            Remove Item
          </Text>
        </div>
      );
    const selectedProduct = this.state.selected.value.product || {};
    const priceDiff =
      product.sku_id === selectedProduct.sku_id
        ? null
        : this.priceDiff(product, selectedProduct);
    return this._renderIngredientOption(product, priceDiff);
  }

  _renderIngredientOption(product, priceDiff = null) {
    return (
      <div className="product-ingredient__row">
        <img className="product-ingredient__img" src={product.image} />
        <div className="product-ingredient__title">
          <Text title className="text-overflow" weight="bold" size="xs">
            {product.title}
            <Text tag="span" className="text-secondary" weight="med" size="xs">
              {product.qty > 1 ? ` x${product.qty}` : ''}
            </Text>
          </Text>
          <Text secondary className="text-overflow" weight="light" size="xs">
            {product.subtitle} | {product.volume}
          </Text>
        </div>
        {!!priceDiff && (
          <Text
            tag="span"
            className="product-ingredient__price"
            secondary
            size="xs"
          >
            {priceDiff}
          </Text>
        )}
      </div>
    );
  }

  priceDiff(product, selectedProduct) {
    const newPrice = product.price || 0;
    const selectedPrice = selectedProduct.price || 0;
    const diff = newPrice.toFixed(2) - selectedPrice.toFixed(2);
    return `${diff >= 0 ? '+' : '-'}$${Math.abs(diff).toFixed(2)}`;
  }

  render() {
    if (!this.state.options.length) return null;
    return (
      <Select
        className="form-field product-ingredient"
        clearable={false}
        searchable={false}
        value={this.state.selected}
        valueRenderer={this.renderValue.bind(this)}
        options={this.state.options}
        optionRenderer={this.renderOption.bind(this)}
        onChange={option => this.select(option)}
      />
    );
  }
}

const ConnectedIngredientSelector = connect(
  state => ({
    selectedIngredients: state.product.selectedIngredients
  }),
  { selectIngredientOption }
)(IngredientSelector);

export default ProductIngredients;



// WEBPACK FOOTER //
// ./shared/components/product/ingredients.js